import QueryString from "qs";
import { useEffect, useState } from "react";
import { TbLogout } from "react-icons/tb";
import { useLocation } from "react-router-dom";
import { getEventCampus } from "../../api/events.api";
import ErrorResponse from "../../components/ErrorResponse";
import NewWindowLayout from "../../components/layout/NewWindowLayout";
import Loader from "../../components/Loader";
import useAxios from "../../hooks/useAxios";
import { IEventParticipant, IGetEventCampus } from "../../models/events.model";
import Block from "../../components/event/attendance/Block";
import PhoneInput from "../../components/event/attendance/PhoneInput";
import Result from "../../components/event/attendance/Result";
import { useTranslation } from "react-i18next";

export enum AttendanceContents {
  Input,
  Result
}

const Attendance = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const eventNo = Number(query.eventNo);
  const type = String(query.type);
  const { data: res, isLoading, error, execute } = useAxios<IGetEventCampus>();

  const [content, setContent] = useState(AttendanceContents.Input);
  const [participant, setParticipant] = useState<IEventParticipant>();

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);
    window.addEventListener("popstate", handlePopstate);
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  useEffect(() => {
    if (type === 'PA' && eventNo) {
      execute(getEventCampus(eventNo));
    }
  }, []);

  const handlePopstate = () => {
    document.location.replace(`/event/${type === 'ED' ? 'education' : 'briefing'}/${eventNo}/register`);
  };

  const renderContent = () => {
    switch (content) {
      case AttendanceContents.Input:
        return (
          <PhoneInput
            setContent={setContent}
            setParticipant={setParticipant}
          />
        );
      case AttendanceContents.Result:
        return (
          <Result
            setContent={setContent}
            participant={participant}
            type={type}
          />
        );
    }
  }

  return (
    <NewWindowLayout title={t('event.attendance.5')} isBoxOff>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Block>
        <div className="header">
          <div className="max-1200p flex-justify-between">
            <div />
            <div className="h-center">
              <div className="v-center">
                <img
                  src="/images/logo.svg"
                  alt="logo"
                  className="logo"
                />
              </div>
              <div className="v-center logo-text">{t('student.student.75')}</div>
              {
                type === 'PA' && (
                  <div className="v-center campus-text">{res?.data?.campusKorName}{t('student.student.76')}</div>
                )
              }
            </div>
            <div className="exit">
              <TbLogout
                className="pointer"
                onClick={() => {  
                  document.location.replace(`/event/${type === 'ED' ? 'education' : 'briefing'}/${eventNo}/register`);
                }}
              />
            </div>
          </div>
        </div>

        <div className="body">
          <div className="max-1200p flex-justify-center">
            {renderContent()}
          </div>
        </div>
      </Block>
    </NewWindowLayout>
  );
}

export default Attendance;
